<template>
  <div class="header wrapper">
    <h1>
      <img :src="header3Image">
<!--      <QRCodeComponent />-->
    </h1>
    <div class="nav">
      <ul>
<!--        <li><router-link to="/test">协会简介</router-link></li>-->
<!--        <router-view></router-view>-->
        <li><a href="#">协会简介</a></li>
        <li><a href="#">会员风采</a></li>
        <li><a href="#">党建活动</a></li>
      </ul>
    </div>
    <div class="search">
      <input type="text" placeholder="请输入要搜索的信息"><button></button>

    </div>
<!--    <div class="user">-->
<!--&lt;!&ndash;    <img :src="touxiangImage" >&ndash;&gt;-->
<!--      <QRCodeComponent />-->
<!--    <span><router-link to="/test">会员注册</router-link></span>-->
<!--      <router-view></router-view>-->
<!--    </div>-->
    <div class="user">
      <div class="qrcode-container">
        <QRCodeComponent />
      </div>
      <span><router-link to="/RegisterPage">入会注册</router-link></span>
      <router-view></router-view>
    </div>
  </div>

  <div class="banner">
    <div class="wrapper">
      <div class="left" >
        <ul>
          <li><a href="#">集成电路行业<span>></span></a> </li>
          <li><a href="#">生物医药行业<span>></span></a> </li>
          <li><a href="#">人工智能行业<span>></span></a> </li>
          <li><a href="#">电子信息行业<span>></span></a> </li>
          <li><a href="#">生命健康行业<span>></span></a> </li>
          <li><a href="#">先进材料行业<span>></span></a> </li>
          <li><a href="#">时尚消费行业<span>></span></a> </li>
          <li><a href="#">元宇宙行业<span>></span></a> </li>
          <li><a href="#">绿色低碳行业<span>></span></a> </li>
        </ul>
      </div>
      <div class="right">
        <h2>通知公告</h2>
        <div class="content">
          <dl>
            <dt>专业委员会第五届学术年会第二轮通知</dt>
<!--            <dd>环球影城</dd>-->
          </dl>
          <dl>
            <dt>学专业委员会2024年学术年会第一轮通知</dt>
<!--            <dd>迪士尼乐园</dd>-->
          </dl>
          <dl>
            <dt>关于申办2025年第二十六届学学术会议的通知</dt>
<!--            <dd>长隆欢乐世界</dd>-->
          </dl>
        </div>
        <div>
          <a href="#" class="more">全部内容</a>
        </div>
      </div>
    </div>
  </div>
  <div class="goods wrapper">
    <h2>会员风采</h2>
    <ul>
      <li><a href="http://wglj.suzhou.gov.cn/" target="_blank">备案会员</a></li>
      <li><a href="https://wgly.hangzhou.gov.cn/" target="_blank">注册会员</a></li>
      <li><a href="http://wtl.sz.gov.cn/" target="_blank">理事会会员</a></li>
      <li><a href="https://whlyj.sh.gov.cn/" target="_blank">分会会员</a></li>
      <li><a href="http://wlj.wuhan.gov.cn/" target="_blank">会员协议</a></li>
      <li><a href="https://www.discoverhongkong.cn/index.html" target="_blank">会员福利</a></li>
      <li><a href="https://www.discoverhongkong.cn/index.html" target="_blank">会费标准</a></li>


    </ul>
    <span class="xingqu"><router-link to="/backLogin">会员管理中心</router-link></span>
  </div>

  <div class="jingpin wrapper ">
    <h2></h2>
    <a href="#"></a>
  </div>



  <div class="banquan">
    <span>上海XX协会会员管理中心 协会会员经营许可证编号：L-SH-CJ00056</span><br>
    <span>Copyright©2019</span>
  </div>

</template>

<script>
import header3 from '../assets/img/tubiao.png';
import touxiang from '../assets/img/touxiang.jpg';
import QRCodeComponent from '@/components/QRCodeComponent';
export default {
  name: "mainScreen",
  components: {
    QRCodeComponent // 注册 QRCodeComponent
  },
  data() {
    return {
      header3Image: header3,
      touxiangImage:touxiang,// 将图片路径作为数据属性
      qrCodeUrl: 'http://localhost:8080/test' // 指向本地开发服务器的地址
    };
  },
}
</script>

<style scoped>
@import "../assets/css/index.css";

</style>